__webpack_require__.p = "https://static.parastorage.com/services/restaurants-orders-ooi/18ccf5b59de99c35c4180aea6411933948f03e688c8ea2c6fc075cb4/";